import { Controller } from 'stimulus'
import Swiper from 'swiper'
import EventEmitter from "../utils/EventEmitter";

export default class extends Controller {

    static targets = [
        "container", "nextButton", "prevButton"
    ]

    get name() {
        return this.data.get("name")
    }

    initialize() {

        const name = this.name
        this.eventSliderIndexHasChanged = `slider-index-changed-${name}`

        let options = {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            threshold: 20,
            navigation: {
                nextEl: this.nextButtonTarget,
                prevEl: this.prevButtonTarget,
            }
        }

        options = Object.assign({}, options, this.options)

        this.swiper = new Swiper(this.containerTarget, options)

        EventEmitter.on(this.eventSliderIndexHasChanged, (e) => {
            const index = parseInt(e.detail.index)
            console.log(index)
            if ( isNaN(index)) {
                return
            }
            if ( options.loop ) {
                this.swiper.slideToLoop(index, 10)
            } else {
                this.swiper.slide(index, 10)
            }
        })

    }

    get options() {
        const options = this.data.get("options")
        return options ? JSON.parse(options) : {}
    }

}
